import { MegaphoneIcon, XMarkIcon } from '@heroicons/react/24/outline'

export default function Example() {
    return (

        <div className="mx-auto ">
            <div className="rounded-lg bg-gray-100  shadow-lg ">
                <div className="flex flex-wrap items-center">
                    <div className="flex w-0 flex-1 items-center">
                        <span className="flex rounded-lg p-2">
                            <MegaphoneIcon className="h-6 w-6 text-black" aria-hidden="true" />
                        </span>
                        <div className="pr-16 sm:px-16 sm:text-center">
                        <p className="ml-3 truncate font-medium text-black text-center">1 Contract is worth 1 ICP Payout</p>
                        </div>
                    </div>
                    
                    
                </div>
            </div>
        </div>

    )
}
